import { Geolocation } from '@capacitor/geolocation';

export async function startGeolocating(handler) {
    const coordinates = await Geolocation.watchPosition(
        {enableHighAccuracy: true}, handler);
}
